import styled from 'styled-components'

export const NotificationsStyle = styled.div`
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex;

  .loadingNotification{
      border-radius: 50%;
      height: 25px;
      width: 25px;
      margin: 0;
      position: absolute;
      display: grid;
      margin-left: 33px;
      top: 5px;

      // @media (max-width: 1500px) {
      //   height: 30px;
      //   width: 30px;
      //   margin-left: 30px;
      // }

      // @media (max-width: 1300px) {
      //   height: 25px;
      //   width: 25px;
      //   margin-left: 26px;
      // }

      // @media (max-width: 1100px) {
      //   height: 20px;
      //   width: 20px;
      //   margin-left: 22px;
      //   margin-left: 17px;
      //   top: 3px;
      // }
  }

  .headerIconNotification {
    border: 2px solid #CD335E;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    margin: 0;
    top: 7px;
    position: absolute;
    display: grid;
    background: #1C2937;
    margin-left: 20px;

    > span {
        font-size: 10px;
        margin: auto;
        font-weight: 500;
        color: #fff;
    }

    // @media (max-width: 1500px) {
    //   border: 2px solid #CD335E;
    //   height: 30px;
    //   width: 30px;
    //   margin-left: 30px;

    //   > span {
    //       font-size: 13px;
    //   }
    // }

    // @media (max-width: 1300px) {
    //   border: 1px solid #CD335E;
    //   height: 25px;
    //   width: 25px;
    //   margin-left: 26px;

    //   > span {
    //       font-size: 12px;
    //   }
    // }

    // @media (max-width: 1100px) {
    //   border: 1px solid #CD335E;
    //   height: 20px;
    //   width: 20px;
    //   margin-left: 22px;

    //   > span {
    //       font-size: 10px;
    //   }
    // }



  }

  .notification-menu-drop{
    position: absolute;
    background: var(--white);
    width: 460px;
    right: 115px;
    top: 80px;
    border-radius: 0.5rem;
    box-shadow: 0px 16px 44px -25px rgba(0, 0, 0, 0.25);
    z-index: 2;
    
    .notification-menu-drop-list {
      overflow-y: scroll;
      max-height: 70vh;
      
      &::-webkit-scrollbar {
        width: 7px;

        &-track {
          box-shadow: inset 0 0 5px #ccc; 
        }

        &-thumb {
          background: linear-gradient(231.01deg,#E6037F 20.98%,#99175C 90.65%); 
          border-radius: 10px;
        }
      }
    }

    &:before {
      content: "";
      position: absolute;
      display: inline-block;
      vertical-align: middle;
      top: -20px;
      left: 208px;
      width: 0px; 
      height: 0px; 
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid var(--white);
    }

    &-title{
      padding: 1rem;
      border-bottom: 1px solid var(--gray-200);
      display: flex;
      justify-content: space-between;

      h3{
        font-size: 22px;
        font-weight: 400;
      }

      span {
        background: #F5222D;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }
  }
`

export const Item = styled.div`
  display: flex;
  padding: 15px;
  border-bottom: 1px solid var(--gray-200);
  cursor: pointer;
  position: relative;
  transition: background 0.2s;

  &:hover{
    background: var(--gray-100);
  }

  a, >div {
    text-decoration: none;
    color: var(--black);
    width: 100%;

    .notification-menu-item-sections{
      display: flex;
      justify-content: space-between;
      align-items: center;

      .meta {
        display: flex;
        align-items: center;

        img{
          margin-right: 15px;
          height: 24px;
        }

        h3{
          font-size: 18px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;  
          overflow: hidden;
        }
      }
    }
  }
`

export const ModalContentCC = styled.div`
  width: 490px;
  max-width: 65vw;

  .steps {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 20px;
  }

  >p {
    text-align: center;
    margin-bottom: 15px;
  }

  .options {
    display: flex;
    flex-direction: column;
    
    button {
      margin: 5px 0;
      text-align: left;
      padding: 10px;
      font-size: .9rem;
      border-radius: 9px;
      border: solid 2px transparent;
      border: none;

      &.active {
        border: solid 2px #777;
        background: #cccccc;
      }
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;

    button {
      width: 100%;
      height: 45px;
      border: 1px solid var(--gray-200);
      background: var(--white);
      border-radius: 0.5rem;
      font-size: .8rem;
      font-weight: 600;
      background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
      color: var(--white);
      margin: 0 1px;
    }
  }

  .input-box {
    margin: 30px 0;

    label {
      font-size: 18px;
      margin-right: 10px;
    }

    input {
      border: none;
      background: #eaeaea;
      width: 200px;
      height: 40px;
      border-radius: 5px;
      outline: none;
      padding: 10px;
    }
  }
`

export const ModalContentCCFirst = styled.div`
  p {
    margin: 10px 0;
    text-align: center;
  }

  h4 {
    text-align: center;
    margin: 10px 0 20px;
  }

  .descriptionCC {
    margin: 10px 0;
    text-align: center;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    button {
      width: 100%;
      height: 45px;
      border: 1px solid var(--gray-200);
      background: var(--white);
      border-radius: 0.5rem;
      font-size: .8rem;
      font-weight: 600;
      background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
      color: var(--white);
      margin: 0 1px;
    }
  }
`
